export const Shield = ({
  verified,
  intermediate
}: {
  verified: boolean;
  intermediate: boolean;
}) => {
  const src = verified
    ? intermediate
      ? "/images/olkypass/orange_shield.svg"
      : "/images/olkypass/green.svg"
    : "/images/olkypass/white.svg";
  return (
    <div className={`flex items-center justify-center ${!verified ? "pt-1" : "	"}`}>
      <img src={src} alt="" />
    </div>
  );
};
